import React, {Component} from 'react';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import Fade from 'react-reveal/Fade';
import d from './img/map.png';
import ddd from './img/mail.png'
import './About.css';
import { Button } from 'react-bootstrap';
////import GoogleMapReact from 'google-map-react';



const now = new Date();
const day = now.getDay(); // 0=ראשון, 1=שני, ..., 5=שישי, 6=שבת
const hour = now.getHours();
const minute = now.getMinutes();

const currentTime = hour * 60 + minute;
const openTime = 8 * 60;   // 08:00
const closeTime = 20 * 60; // 20:00

const isOpen =
  day >= 0 &&
  day <= 4 &&
  currentTime >= openTime &&
  currentTime < closeTime;


class About extends Component {
render() {

return (
    <div>


    <div className="textttttt" >
    <Fade top>
    <p></p><p></p><p></p><p></p>
   

<p > משרדנו - מתחם הבורסה, מגדלי פז - רחוב שוהם 5, רמת גן  &nbsp; <img className="im" src={d} alt="1"/> </p>
<br></br>


    </Fade>

    </div>
 <div class="google-maps" >

 <br></br>


<Map 
google={this.props.google}
zoom={15}
fullscreenControl= {true}
zoomControl= {true}
streetViewControl= {true}





initialCenter={{ lat: 32.084890, lng: 34.800629}} 


>


<Marker position={{ lat: 32.084890, lng: 34.800629}}  title="רחוב שוהם 5"  />
</Map>


 </div>

 <div className="abc">


</div>


        <div className="cards">

          <div className="card">
            <h3>📞 טלפון</h3>
            <p>052-4816141</p>
            <a href="tel:0506978865" className="btn">חייג עכשיו</a>
          </div>


          <div className="card">
            <h3>📧 אימייל</h3>
            <p>shani.aviv.arch@gmail.com</p>
            <a target="_blank" href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=shani.aviv.arch@gmail.com" className="btn">שלח מייל</a>
          </div>

<div className="card">
  <h3>📍 משרדנו</h3>
  <p>רחוב שוהם 5, רמת גן</p>
<a
  href="https://waze.com/ul?ll=32.084422,34.800719&navigate=yes"
  target="_blank"
  rel="noopener noreferrer"
  className="btn"
>
  ניווט ב-Waze
</a>
</div>
<div className="card">
  <h3>🕒 שעות פעילות</h3>
    <p>
 {hour}:{String(minute).padStart(2, "0")}
</p>
  <ul className="hours">
    <li>ראשון - חמישי: 08:00 - 20:00</li>
    <li>שישי: סגור</li>
    <li>שבת: סגור</li>

  </ul>

 <span className={`status ${isOpen ? "open" : "closed"}`}>
  ● {isOpen ? "פתוח עכשיו" : "סגור עכשיו"}
</span>   

</div>

        </div>

 </div>




 );



 }

}


export default GoogleApiWrapper({
    apiKey: ("AIzaSyC2H55uGYHc55B2L3CwQd2Jzijoj_isaU0"),
    language:("hebrew"),
    region:("jp"),
    
})(About);



///const mapStyles = {

 //   width: '40%',
 //   height: '40%',
 //   left: 0,
 //   top: 0,
 //   margin: 10,
 //   padding: 150,
///    position: 'absolute',
  //  display:'flex',
 //   flexdirection:'row',
  //  justifycontent:'space-evenly',
//   alignitems:'flex-end',
 //  backgroundattachment:'fixed', 
 //  backgroundposition:'center' 
  
  


    
 // };


/// <Map 
///google={this.props.google}
////zoom={14}


  ///// <Button  className="textttttt" a href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to= shani.aviv.arch@gmail.com" target="_blank"   variant="Light" >  shani.aviv.arch@gmail.com - שלחו לנו הודעה ונחזור אליכם &nbsp;<img className="im" src={ddd} alt="1"/>  </Button>



/////initialCenter={{ lat: 32.084890, lng: 34.800629}} 


///>


  
///<Marker position={{ lat: 32.084890, lng: 34.800629}}  title="רחוב שוהם 5"  />
///</Map>

//////////<a href="tel:052-4816141" target="_blank"> <p><span></span>  יצירת קשר - 052-4816141 &nbsp; <img className="im" src={dd} alt="1"/> </p></a>